import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(AuthContext);

  // If no logged-in admin found → redirect to login page
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Otherwise, allow access to the protected page
  return children;
};

export default ProtectedRoute;
